import type { EnvSection } from '@cli-types/core-engine/env.js'
import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { collectR2Config } from './collect-r2-config.js'
import { collectRailwayBucketConfig } from './collect-railway-bucket-config.js'
import { collectResendConfig } from './collect-resend-config.js'
import { collectVercelBlobConfig } from './collect-vercel-blob-config.js'
import { resolveIntegrationInstallOrder } from './resolve-integration-install-order.js'

export async function collectIntegrationConfig(
  cwd: string,
  integrationIds: BetterstartIntegrationId[]
): Promise<CollectedIntegrationConfig> {
  const sections: EnvSection[] = []
  const overwriteKeys = new Set<string>()

  for (const integrationId of resolveIntegrationInstallOrder(integrationIds)) {
    const definition = getIntegrationDefinition(integrationId)
    const collected =
      definition.configure === 'resend'
        ? await collectResendConfig(cwd)
        : definition.configure === 'r2'
          ? await collectR2Config(cwd)
          : definition.configure === 'vercel-blob'
            ? await collectVercelBlobConfig(cwd)
            : definition.configure === 'railway-bucket'
              ? await collectRailwayBucketConfig(cwd)
              : undefined

    if (!collected) {
      continue
    }

    sections.push(...collected.sections)
    for (const key of collected.overwriteKeys) {
      overwriteKeys.add(key)
    }
  }

  return { sections, overwriteKeys }
}
